import { Image } from './image.model';
import { ImageSearchParams } from './image-search-params.model';
import { ImageSearchResult } from './image-search-result.model';
import { ImageUpload } from './image-upload.model';
import { Injectable } from '@angular/core';
import { IImageService } from './iimage.service';
import { ConfigService } from '../config.service';
import { AppContext } from '../app-context.model';
import { ApiService, ApiCacheOptions, AuthService } from '../../../shared/index';

@Injectable()
export class ImageService implements IImageService {
  public _apiService: ApiService;
  public _configService: ConfigService;
  public _appContext: AppContext;
  private _cacheOptions: ApiCacheOptions;
  public constructor(apiService: ApiService, configService: ConfigService, private _authService: AuthService) {
    this._apiService = apiService;
    this._configService = configService;
    this._cacheOptions = this._apiService.getDefaultApiCacheOptionsForInfrequentlyChangedData();
  }

  getImageUploadAbsoluteUrl = (): string => {
    return this._apiService.getBaseUrl() + '/Image/Upload';
  };
  getWebContentImageUploadAbsoluteUrl = (): string => {
    return this._apiService.getBaseUrl() + '/Image/WebContent/Upload';
  };

  getWebContentProfileImageUploadAbsoluteUrl = (profileId: number): string => {
    return this._apiService.getBaseUrl() + '/Image/WebContent/Upload/' + profileId.toString();
  };

  searchImages = (params: ImageSearchParams): Promise<ImageSearchResult> => {
    let result = new ImageSearchResult();

    return this._apiService.getPaged('/Images', params, this._cacheOptions);
  };

  getWebContentImageSourceUrl = (contentId: number): string => {
    let result = this._apiService.getBaseUrl() + '/Image/WebContent/' + contentId.toString() + '?x-tenant=' + this._authService.getTenant();
    return result;
  };

  getLastWebContentImage = (): Promise<Image> => {
    return this._apiService.get('Image/WebContent/Last');
  };

  getLastProfileWebContentImage = (profileId: number): Promise<Image> => {
    return this._apiService.get('Image/WebContent/Last/' + profileId.toString());
  };
}
